import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliverableProjectActivitiesDataGrid } from "src/components/views/erp/project/delivery/DeliverableProjectActivitiesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/deliverableActivities")({
	staticData: { title: i18n.t("deliverable_activities"), legacyViewKey: "deliverableProjectActivitiesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliverableProjectActivitiesDataGrid />;
}
